import { render, staticRenderFns } from "./TepDashboardNacionalIndex.vue?vue&type=template&id=70a73222"
import script from "./TepDashboardNacionalIndex.vue?vue&type=script&lang=js"
export * from "./TepDashboardNacionalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports